import { FormV2TypeEnum } from 'src/app/form-builder/shared/enum/form-v2-type.enum';
import { FormGroup } from './form-group.model';
import { FormBuilderSettings } from './settings/form-builder-settings.model';

export class FormTemplate {
  public constructor() {
    this.Id = 0;
    this.Name = '';
    this.Title = '';
    this.FormGroups = new Array<FormGroup>();
    this.FormSettings = new FormBuilderSettings();
    this.Inactive = false;
  }

  public Id: number;
  public InvoiceNum: number;
  public Name: string;
  public Title: string;
  public FormGroups: Array<FormGroup>;
  public FormSettings: FormBuilderSettings;
  public FormType: number;
  public Inactive: boolean;
}
